module.exports = __webpack_public_path__ + "img/listBg2.da818563.png";